import { createContext } from 'react';

/**
 * @type {React.Context<Array<object>>}
 */
export const LimitsContext = createContext(undefined);

/**
 * @type {React.Context<React.Dispatch<React.SetStateAction<Array<object>>>>}
 */
export const UpdateLimitsContext = createContext(def => def);
